class NotStepInstance extends Error {}

export default NotStepInstance;
